export const ExtractValue = (value = '', wordsToReplace) => {
  let result = value
  for (const word of wordsToReplace) {
    result = result ? result.replace(word, '') : ''
  }

  return result
}
